if (!customElements.get('cross-sell')) {
  // Define a custom element called 'cross-sell'
  class CrossSell extends HTMLElement {
    constructor() {
      super();

      // Initialize an empty array to store cross-sell items
      window.crossSellItems = [];

      // Get the add button element
      this.addButton = document.querySelector('[data-main-product] product-form [name="add"] span');

      // Bind events to the button
      this.bindEvents();
    }

    /**
     * Binds the events to the button
     * @returns {void}
     * @memberof CrossSell
     * @inner
     */
    bindEvents() {
      // Get the button element inside the 'cross-sell' element
      this.button = this.querySelector('button');

      // Assign the global cross-sell items array to a local variable
      crossSellItems = window.crossSellItems;

      // Add a click event listener to the button
      this.button.addEventListener('click', () => {
        // Create a form item object with id and quantity properties
        const formItem = {
          id: parseInt(this.dataset.id),
          quantity: parseInt(this.dataset.quantity),
        };

        // Toggle the selected state of the cross-sell item
        this.dataset.selected == 'true'
          ? ((this.dataset.selected = 'false'),
            (crossSellItems = [...crossSellItems.filter((item) => item.id !== formItem.id)]))
          : ((this.dataset.selected = 'true'), (crossSellItems = [...crossSellItems, formItem]));

        // Toggle the text of the add button based on the selected items
        crossSellItems.length > 0
          ? this.toggleAddButtonText(true)
          : this.toggleAddButtonText(false);
      });
    }

    /**
     * Toggles the text of the add button based on the selected items
     * @param {boolean} flag - Flag indicating whether there are selected items
     */
    toggleAddButtonText(flag) {
      // If the add button element doesn't exist, return
      if (!this.addButton) return;

      // Toggle the text of the add button based on the flag
      flag
        ? (this.addButton.textContent = window.crossSellStrings.addAllToCart)
        : (this.addButton.textContent = window.crossSellStrings.addToCart);
    }
  }

  // Define the 'cross-sell' custom element
  customElements.define('cross-sell', CrossSell);
}
